export default "__VITE_ASSET__CWLScZ$q__"